import { render, staticRenderFns } from "./OpenlayersMap.vue?vue&type=template&id=79b4a824&scoped=true&"
import script from "./OpenlayersMap.vue?vue&type=script&lang=js&"
export * from "./OpenlayersMap.vue?vue&type=script&lang=js&"
import style0 from "./OpenlayersMap.vue?vue&type=style&index=0&id=79b4a824&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b4a824",
  null
  
)

export default component.exports